import React from "react"
import classNames from "classnames"
import classes from "./index.module.css"
import {
  WarningIcon,
  InformationIcon,
  ErrorIcon,
  CheckmarkIcon,
} from "../../icons"

type AlertSeverity = "success" | "info" | "warning" | "error"
type AlertVariant = "outlined" | "filled"

interface Props {
  children: React.ReactNode
  severity: AlertSeverity
  variant?: AlertVariant
  className?: string
  iconContainerClassNames?: string
  iconClassName?: string
  show: boolean
  noMargin?: boolean
  icon?: React.ReactNode
}

const severityColors: any = {
  "success.filled": "bg-success text-successText",
  "info.filled": "bg-info text-infoText",
  "warning.filled": "bg-warning text-warningText",
  "error.filled": "bg-error text-white",
  "success.outlined": "border border-successText text-successText",
  "info.outlined": "border border-infoText text-infoText",
  "warning.outlined": "border border-error text-error",
  "error.outlined": "border border-error text-error",
}

const CustomAlert = ({
  children,
  severity,
  className,
  iconClassName,
  show,
  iconContainerClassNames,
  icon,
  variant,
  noMargin,
}: Props) => {
  if (show === false) {
    return <></>
  }
  if (icon == null) {
    switch (severity) {
      case "success":
        icon = (
          <CheckmarkIcon className={classNames("w-5 h-5", iconClassName)} />
        )
        break
      case "info":
        icon = (
          <InformationIcon className={classNames("w-5 h-5", iconClassName)} />
        )
        break
      case "warning":
        icon = <WarningIcon className={classNames("w-5 h-5", iconClassName)} />
        break
      case "error":
        icon = <ErrorIcon className={classNames("w-5 h-5", iconClassName)} />
        break

      default:
        icon = <></>
        break
    }
  }

  return (
    <div
      className={classNames(
        !noMargin && "my-4",
        "flex gap-3 p-4 pr-12 border-0 relative transition-all duration-300",
        severityColors[`${severity ?? "success"}.${variant ?? "filled"}`],
        className
      )}
    >
      <span className={classNames(classes.icon, iconContainerClassNames)}>
        {icon}
      </span>
      <div className={classes.message}>{children}</div>
    </div>
  )
}

CustomAlert.defaultProps = {
  severity: "success",
  variant: "filled",
  show: true,
}

export default CustomAlert
